import React from "react"
import { RoleSlugEnum } from "generated/graphql-types"

import { useUserContext } from "../../context/UserContext"

const AdministratorScopeRouter = React.lazy(
	() =>
		import(
			/*
			webpackChunkName: "administrator-scope"
		 */
			"./Administrator/AdministratorScopeRouter"
		)
)
const ProductionScopeRouter = React.lazy(
	() =>
		import(
			/*
			webpackChunkName: "production-scope"
		 */
			"./Production/ProductionScopeRouter"
		)
)
const ImporterScopeRouter = React.lazy(
	() =>
		import(
			/*
			webpackChunkName: "importer-scope"
		 */
			"./Importer/ImporterScopeRouter"
		)
)

const ScopeSelector: React.FC = () => {
	const {
		user: {
			role: { slug },
		},
	} = useUserContext()

	switch (slug) {
		case RoleSlugEnum.Administrator:
			return <AdministratorScopeRouter />
		case RoleSlugEnum.Production:
			return <ProductionScopeRouter />
		case RoleSlugEnum.Importer:
			return <ImporterScopeRouter />
		default:
			return null
	}
}

export default ScopeSelector
